import React from "react";
import { AnimatePresence, motion } from "framer-motion";
import { AlertTriangle, X } from "lucide-react";

const ConfirmationAlert = ({
  show,
  title = "Are you sure?",
  message = "Do you want to continue?",
  onConfirm,
  onCancel,
}) => {
  return (
    <AnimatePresence>
      {show && (
        <>
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 0.4 }}
            exit={{ opacity: 0 }}
            transition={{ duration: 0.25 }}
            className="fixed inset-0 bg-black/70 backdrop-blur-sm z-40"
            onClick={onCancel}
          />

          <motion.div
            initial={{ opacity: 0, scale: 0.95 }}
            animate={{ opacity: 1, scale: 1 }}
            exit={{ opacity: 0, scale: 0.95 }}
            transition={{ duration: 0.2 }}
            className="fixed inset-0 flex items-center justify-center z-50"
            onClick={onCancel}
          >
            <div
              className="bg-white rounded-xl shadow-lg w-[350px] border border-gray-200 overflow-hidden"
              onClick={(e) => e.stopPropagation()}
            >
              {/* Header */}
              <div className="flex justify-between items-center px-4 py-3 border-b">
                <h2 className="text-lg font-semibold text-gray-800">{title}</h2>
                <button onClick={onCancel}>
                  <X size={20} className="text-gray-500 hover:text-gray-700" />
                </button>
              </div>

              {/* Content */}
              <div className="p-5 text-center">
                <AlertTriangle
                  size={34}
                  className="text-[#0061A4] mx-auto mb-3"
                />
                <p className="text-gray-700 text-sm">{message}</p>
              </div>

              {/* Footer Buttons */}
              <div className="flex justify-end gap-2 px-5 py-3 border-t bg-gray-50">
                <button
                  onClick={onCancel}
                  className="px-4 py-2 text-sm border rounded-md hover:bg-gray-100 transition"
                >
                  Cancel
                </button>

                <button
                  onClick={onConfirm}
                  className="px-5 py-2 text-sm text-white rounded-md bg-gradient-to-r from-[#0061A4] to-[#00ACED] transition"
                >
                  Confirm
                </button>
              </div>
            </div>
          </motion.div>
        </>
      )}
    </AnimatePresence>
  );
};

export default ConfirmationAlert;
